import { doc, DocumentReference, DocumentSnapshot } from 'firebase/firestore';
import { doc as rxDoc } from 'rxfire/firestore';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../types';
import { authenticatedUserProvider } from './userProvider';
import { ICoach } from './usersProvider';

interface IHasTemplate {
  userId: string;
  hasTemplate: boolean;
}

export interface IUserHasTemplateMap {
  [userId: string]: boolean;
}

export const templateProvider = (
  users: ICoach[],
  reportType: string,
  templateId: string
): Observable<IUserHasTemplateMap> => {
  return authenticatedUserProvider().pipe(
    switchMap((authedUser: IUser): Observable<IUserHasTemplateMap> => {
      const templateQueries: Array<Observable<IHasTemplate>> = users.map(
        (user: ICoach): Observable<IHasTemplate> => {
          const userId = user.id;
          return rxDoc(
            doc(
              authedUser.services.firestore,
              `userProfiles/${userId}/settings/${reportType}/templates/${templateId}`
            )
          ).pipe(
            map((template: DocumentSnapshot): IHasTemplate => {
              return { userId, hasTemplate: template.exists() };
            })
          );
        }
      );
      return combineLatest(templateQueries).pipe(
        map((queryResults: IHasTemplate[]): IUserHasTemplateMap => {
          return queryResults.reduce(
            (
              acc: IUserHasTemplateMap,
              result: IHasTemplate
            ): IUserHasTemplateMap => {
              acc[result.userId] = result.hasTemplate;
              return acc;
            },
            {} as IUserHasTemplateMap
          );
        })
      );
    })
  );
};
